export default {
  url: 'https://tenantapi.sherpadm.com/admin',
  path: {
    default: 'tenants',
  },
}
